import PropTypes from "prop-types";
import { add, multiply, subtract } from "lodash";
import { jsx as _jsx } from "react/jsx-runtime";
const Count = _ref => {
  let {
    currentPage = null,
    per = null,
    totalCount = null
  } = _ref;
  if (!currentPage || !per || !totalCount) {
    return null;
  }
  const start = add(1, multiply(per, subtract(currentPage, 1))) <= 1 ? 1 : add(1, multiply(per, subtract(currentPage, 1)));
  const end = multiply(per, currentPage) > totalCount ? totalCount : multiply(per * currentPage);
  return /*#__PURE__*/_jsx("span", {
    className: "text-sm text-brand-blue font-regular-font",
    children: `${start}-${end} of ${totalCount}`
  });
};
Count.propTypes = {
  currentPage: PropTypes.number,
  per: PropTypes.number,
  totalCount: PropTypes.number
};
export default Count;
//# sourceMappingURL=Count.js.map